import { canAccessAdmin, canAdminister, canModerate } from '@cult/domain';
import type { PublicUser } from '@cult/schemas';

export type AdminGuardResult = { ok: true } | { redirectTo: '/login' | '/' | '/admin/ideas' };

/** The /admin area is open to anyone who can moderate ideas — admins, managers and idea managers. */
export const evaluateAdminAccess = (me: PublicUser | null): AdminGuardResult => {
  if (!me) return { redirectTo: '/login' };
  if (!canAccessAdmin(me.role)) return { redirectTo: '/' };
  return { ok: true };
};

/** Praises, feedback, people and statistics need full moderator rights; idea managers are bounced to ideas. */
export const evaluateModeratorAccess = (me: PublicUser | null): AdminGuardResult => {
  if (!me) return { redirectTo: '/login' };
  if (!canModerate(me.role)) return { redirectTo: '/admin/ideas' };
  return { ok: true };
};

/** Access + market sub-areas are admin-only; moderators are bounced to ideas moderation. */
export const evaluateAdminOnlyAccess = (me: PublicUser | null): AdminGuardResult => {
  if (!me) return { redirectTo: '/login' };
  if (!canAdminister(me.role)) return { redirectTo: '/admin/ideas' };
  return { ok: true };
};
